import BadgeIcon from "components/badgeIcon";
import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import ItemOption from "./itemOption";

interface IProps {
  name: string;
  role?: string;
  deleteItem: () => void;
  editItem: () => void;
  type: "Artist" | "Writer" | "Contributor";
}
const ArtistItem = ({ name, role, deleteItem, editItem, type }: IProps) => {
  const [editOpen, setEditOpen] = useState(false);
  return (
    <Container>
      {type !== "Writer" ? (
        <BadgeIcon name={name} size="3.2" />
      ) : (
        <WriterIconContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.9987 6.66683C9.47146 6.66683 10.6654 5.47292 10.6654 4.00016C10.6654 2.5274 9.47146 1.3335 7.9987 1.3335C6.52594 1.3335 5.33203 2.5274 5.33203 4.00016C5.33203 5.47292 6.52594 6.66683 7.9987 6.66683Z"
              stroke="#4E4E4E"
            />
            <path
              d="M13.3346 11.6665C13.3346 13.3234 13.3346 14.6665 8.0013 14.6665C2.66797 14.6665 2.66797 13.3234 2.66797 11.6665C2.66797 10.0096 5.05578 8.6665 8.0013 8.6665C10.9468 8.6665 13.3346 10.0096 13.3346 11.6665Z"
              stroke="#4E4E4E"
            />
          </svg>
        </WriterIconContainer>
      )}

      <NameRole>
        <Typography size="s" weight="semibold" color="#FBFBFB">
          {name}
        </Typography>
        {role && (
          <Typography size="xs" mt="0.5" color={Colors.grey400}>
            {role}
          </Typography>
        )}
      </NameRole>
      {role !== "Primary Artist" && (
        <ThreeDots
          onClick={() => {
            setEditOpen(!editOpen);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12.0391 7.00049C10.9345 7.00049 10.0391 6.10506 10.0391 5.00049C10.0391 3.89592 10.9345 3.00049 12.0391 3.00049C13.1437 3.00049 14.0391 3.89592 14.0391 5.00049C14.0391 6.10506 13.1437 7.00049 12.0391 7.00049Z"
              fill="#CDCDCD"
            />
            <path
              d="M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
              fill="#CDCDCD"
            />
            <path
              d="M11.9609 21C10.8563 21 9.96094 20.1046 9.96094 19C9.96094 17.8954 10.8563 17 11.9609 17C13.0655 17 13.9609 17.8954 13.9609 19C13.9609 20.1046 13.0655 21 11.9609 21Z"
              fill="#CDCDCD"
            />
          </svg>
        </ThreeDots>
      )}
      {editOpen && (
        <ItemOption
          type={type}
          deleteItem={deleteItem}
          editItem={editItem}
          setActive={(bool) => setEditOpen(bool)}
        />
      )}
    </Container>
  );
};

export default ArtistItem;

const Container = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
  position: relative;
`;

const WriterIconContainer = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background-color: ${Colors.grey700};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
`;
const NameRole = styled.div`
  margin-left: 0.8rem;
`;

const ThreeDots = styled.div`
  cursor: pointer;
  margin-left: auto;
  width: 2.4rem;
  height: 2.4rem;
`;
